export default function createUserStore() {
    return {
        directory: window.AppConfig.Compass.Providers,
        getLabel(name) {
            let provider = name;

            if (this.directory.hasOwnProperty(name)) {
                provider = this.directory[name];
            }

            return provider;
        },
        isAdmin(email) {
            const admin = [
                "miquel@brazilliance.co",
                "tjones@clevelandtaskforce.org",
                "ckrueger@clevelandtaskforce.org"
            ];

            if (admin.includes(email)) {
                return true;
            }

            return false;
        },
        isAuthor(author, userFirstName, userLastName) {
            const authorName = this.getLabel(author);
            const userName = `${userFirstName.charAt(0)}. ${userLastName}`;

            if (authorName === userName) {
                return true;
            }

            return false;
        },
        isReviewer(email) {
            const reviewers = ["vpasalic@clevelandtaskforce.org"];

            if (reviewers.includes(email)) {
                return true;
            }

            return false;
        },
    };
}